module.exports = __webpack_public_path__ + "img/heart_bj.9735c9c9.png";